export const slugify = (...args: (string | number)[]): string => {
  const value = args.join(' ');

  return value
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD') // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .trim()
    .replace(/[^a-z0-9 -]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-'); // separator
};

export const mustache = (string: string, data: Object) =>
  Object.entries(data).reduce((res, [key, value]) => {
    const search = `{${key}}`;

    if (
      res.indexOf(search) !== -1 &&
      res.indexOf(`\\${key}`) == -1 && // Escaped on start
      res.indexOf(`${key}\\`) == -1 // Escaped on end
    ) {
      return res.replaceAll(search, value);
    }

    return res;
  }, string);

export function getDownloadUrl(storyblokUrl: string | undefined) {
  if (!storyblokUrl) {
    return;
  }
  // Get the app host from the Nuxt config
  const appHost = (process.env.APP_HOST || 'geigergruppe.com')
    .replace('*.', '')
    .replace('www.', '')
    .replace('https://', '')
    .replace('http://', '');
  return storyblokUrl.replace('a.storyblok.com/f/167299', 'api.' + appHost + '/download');
}
